module.exports = function anonymous(locals, escapeFn, include, rethrow) {
    rethrow = rethrow || function rethrow(err, str, flnm, lineno, esc) {
        var lines = str.split("\n");
        var start = Math.max(lineno - 3, 0);
        var end = Math.min(lines.length, lineno + 3);
        var filename = esc(flnm);
        var context = lines.slice(start, end).map(function(line, i) {
            var curr = i + start + 1;
            return (curr == lineno ? " >> " : "    ") + curr + "| " + line;
        }).join("\n");
        err.path = filename;
        err.message = (filename || "ejs") + ":" + lineno + "\n" + context + "\n\n" + err.message;
        throw err;
    };
    escapeFn = escapeFn || function(markup) {
        return markup == undefined ? "" : String(markup).replace(_MATCH_HTML, encode_char);
    };
    var _ENCODE_HTML_RULES = {
        "&": "&amp;",
        "<": "&lt;",
        ">": "&gt;",
        '"': "&#34;",
        "'": "&#39;"
    }, _MATCH_HTML = /[&<>'"]/g;
    function encode_char(c) {
        return _ENCODE_HTML_RULES[c] || c;
    }
    var __line = 1, __lines = '<%\n/**\n * Whether the blurred background layer should be visible.\n * @name showBackground\n * @type {boolean}\n */\n%>\n<svg version="1.1" width="298" height="298" xmlns="http://www.w3.org/2000/svg">\n\n  <% if (showBackground) { %>\n    <filter id="backgroundBlur">\n      <feGaussianBlur in="SourceGraphic" stdDeviation="5" />\n      <feComponentTransfer>\n        <feFuncA slope="0.5" type="linear"></feFuncA>\n      </feComponentTransfer>\n    </filter>\n  <% } %>\n\n  <g id="centered-group" transform="translate(150,150)">\n    <g id="background-group"\n       <% if (showBackground) { %>\n         filter="url(#backgroundBlur)"\n       <% } else { %>\n         visibility="hidden"\n       <% } %>\n        ></g>\n\n    <g id="foreground-group"></g>\n  </g>\n</svg>\n', __filename = "src/netsim/NetSimVisualization.html.ejs";
    try {
        var __output = [], __append = __output.push.bind(__output);
        with (locals || {}) {
            __line = 7;
            __append('\n<svg version="1.1" width="298" height="298" xmlns="http://www.w3.org/2000/svg">\n\n  ');
            __line = 10;
            if (showBackground) {
                __append('\n    <filter id="backgroundBlur">\n      <feGaussianBlur in="SourceGraphic" stdDeviation="5" />\n      <feComponentTransfer>\n        <feFuncA slope="0.5" type="linear"></feFuncA>\n      </feComponentTransfer>\n    </filter>\n  ');
                __line = 17;
            }
            __append('\n\n  <g id="centered-group" transform="translate(150,150)">\n    <g id="background-group"\n       ');
            __line = 21;
            if (showBackground) {
                __append('\n         filter="url(#backgroundBlur)"\n       ');
                __line = 23;
            } else {
                __append('\n         visibility="hidden"\n       ');
                __line = 25;
            }
            __append('\n        ></g>\n\n    <g id="foreground-group"></g>\n  </g>\n</svg>\n');
            __line = 31;
        }
        return __output.join("");
    } catch (e) {
        rethrow(e, __lines, __filename, __line, escapeFn);
    }
}